module.exports = __webpack_public_path__ + "img/czleader8.f2b8e00f.png";